import { GUIDE_STEPS, IS_DROPDOWN_OPEN } from './studies.constants';
import { StudiesState } from './studies.model';

export const studiesInitialState: StudiesState = {
  studiesList: null,
  userInput: '',
  selectedStudy: null,
  isDropdownOpen: IS_DROPDOWN_OPEN,
  pagination: {
    currentPage: 1,
    totalPages: 100,
    totalResults: 100,
  },
  guideSteps: GUIDE_STEPS,
  currentStep: GUIDE_STEPS['initialState'],
  isDragging: false,
  translatePos: { x: 0, y: 0 },
  currentProgress: 0,
  primaryMarketPayload: null,
  layoutsValuationPayload: null,
  layoutsValuationPrimaryResponse: null,
  layoutsValuationSecondaryResponse: null,
  polygon: null,
  qualifiedAudience: null,
  absorptionAndLiquidityResponsePrimary: null,
  absorptionAndLiquidityResponseSecondary: null,
  installmentsSimulationPrimary: null,
  installmentsSimulationSecondary: null,
  studyName: '',
  creationDate: '10/03/2023',
  id: '',
  expandedArea: null,
  transactionedMarketCycle: null,
  initialStep: null,
  author: '',
  titleSearchInput: '',
};
